import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TransactionCreateDilaogComponent } from 'app/dialogs/transaction-create-dilaog/transaction-create-dilaog.component';
import { CompanyService } from 'app/services/models/company.service';
import { ProductService } from 'app/services/models/product.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import moment from 'moment';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { DecimalPipe } from '@angular/common';
import feather from 'feather-icons';
import { TransactionService } from 'app/services/models/transaction.service';
import { CreateTransaction } from 'app/dtos/Transaction/createTransaction';
import { CreateTransactionProduct } from 'app/dtos/Transaction/createTransactionProduct';
import { _isId } from 'app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from 'app/services/models/project.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { TransactionDescriptionService } from 'app/services/models/transaction-description.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ConfirmDialogComponent } from 'app/dialogs/confirm-dialog/confirm-dialog.component';
import { CreateCompanyComponent } from 'app/dialogs/create-company/create-company.component';
import { CreateProductComponent } from 'app/dialogs/create-product/create-product.component';

@Component({
  selector: 'app-offer-create',
  templateUrl: './offer-create.component.html',
  styleUrls: ['./offer-create.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OfferCreateComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  @ViewChild('productSelect') productSelect: NgSelectComponent;

  transactionList: any[] = [];
  totalAmount: number | null = null;
  isMobile: boolean;
  privateDescription: string = '';

  constructor(
    private companyService: CompanyService,
    private productService: ProductService,
    private modalService: NgbModal,
    private breakpointObserver: BreakpointObserver,
    private decimalPipe: DecimalPipe,
    private transactionService: TransactionService,
    private toastrService: ToastrService,
    private projectService: ProjectService,
    private transactionDescriptionService: TransactionDescriptionService,
    private router: Router,
    private activadetRouter: ActivatedRoute) { }

  public contentHeader: object;
  public isReadonly = true;
  company: any = null;
  companies: any[] = [];
  selectedCompanyId;
  persons: any[] = [];
  requestTask: any[] = [];
  selectedRequestTaskId = null;
  selectedPersonId = null;
  products: any[] = [];
  project: any[] = [];
  selectedProjectId = null;
  isPrivate: boolean = false;
  docNo?: string = null;
  date = new Date();
  date2 = moment().add(15, 'days').toDate();
  descriptions: any[] = [];
  description: any = {};

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate: this.date
  };

  public dateTimeEndOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate: this.date2
  };


  async ngOnInit() {
    this.activadetRouter.params.subscribe(async params => {
      const data = params['data']
      if (data != null) {
        const data = JSON.parse(params['data']);
        console.log(data);
        this.transactionList = data.transactionManagementProducts.map(item => {
          const totalPrice = item.productPrice * item.productCount;

          // İndirimli fiyat hesaplama
          const discountedPrice = totalPrice - (totalPrice * (item.discountRate / 100));

          // Toplam hesaplama: indirimli fiyat + (indirimli fiyat * vergisi)
          const total = discountedPrice + (discountedPrice * (item.taxRate / 100));

          return {
            product: {
              id: item.productId,
              name: item.productName,
              code: null,
              productType: true,
              unitTypeName: item.unitTypeName,
              unitTypeId: item.unitTypeId,
              currencyId: item.currencyId,
              currencyName: item.currency,
              purchasePrice: null,
              salePrice: item.productPrice,
              purchaseTaxId: null,
              purchaseTax: null,
              saleTax: item.taxRate,
              saleTaxId: item.taxId,
              categoryId: null,
              categoryName: null,
              barcode: null,
              criticalStock: null,
              createdAt: new Date(),
              updateAt: new Date(),
              subProducts: [],
              serials: [],
              labels: [],
              productMovements: [],
              transactionProductsCount: [],
              isDeleted: false
            },
            count: item.productCount,
            selectedWarehouseId: item.warehouseId,
            salePrice: item.productPrice,
            saleTax: item.taxRate,
            saleTaxId: item.taxId,
            discountRate: item.discountRate,
            total: total,
            currencyId: item.currencyId
          };
        });
        console.log(this.transactionList)
        this.calculateVatTotals(this.transactionList);
        await this.onCompanyChange(data.companyId);
        console.log(data.transactionManagementDescriptionConnects)
        this.description = data.transactionManagementDescriptionConnects[0];
      }
    })

    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {

      this.isMobile = result.matches;
    });
    this.contentHeader = {
      headerTitle: 'Teklif',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Teklif Listesi',
            isLink: true,
            link: '/offer'
          },
          {
            name: 'Teklif Oluştur',
            isLink: false,
          },
        ]
      }
    }
    await this.getAllCompanies();
    await this.getAllProducts();
    await this.getAllProjects('');
    await this.getAllDescriptions();
    this.calculateTotalAmount();
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    feather.replace(); // Initialize Feather icons
  }

  async getAllDescriptions() {
    const data = await this.transactionDescriptionService.getAllTransactionDescriptions();
    this.descriptions = data;
  }

  onDescriptionChange(event) {
    console.log(event);
    this.description = event;
  }
  isDiscount: boolean = false;
  isPrivateDiscountToogle() {
    this.isDiscount = !this.isDiscount;
  }

  isPrivateToogle() {
    this.isPrivate = !this.isPrivate;
    feather.replace();
  }

  ngOnDestroy() {
    // `beforeunload` olayını kaldırın
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  handleBeforeUnload = (event: BeforeUnloadEvent) => {
    if (this.transactionList.length > 0) {
      // Prevent default behavior to show the default browser warning
      event.preventDefault();
      // Chrome requires returnValue to be set
      // This is now deprecated but still required for some browsers
      event.returnValue = '';
    }
  }

  onProductChange(selectedProductId: number) {
    console.log("Seçilen ürün ID : ", selectedProductId);
    if (selectedProductId) {
      this.transactionShow(selectedProductId);
    } else {
      console.log("Ürün seçilmedi veya seçim iptal edildi.");
    }
  }

  calculateTotalAmount() {
    this.totalAmount = this.transactionList.reduce((acc, transaction) => acc + (transaction.total || 0), 0);
  }

  updateTransactions(newTransactions: any[]) {
    this.transactionList = newTransactions;
    this.calculateTotalAmount();
  }

  deleteTransaction(index: number) {
    console.log(index);
    if (index > -1) {
      this.transactionList.splice(index, 1);
      this.calculateTotalAmount();
      this.calculateVatTotals(this.transactionList);
      this.calculatePurchaseTaxTotals(this.transactionList);
      this.calculateNetVatDifference(this.transactionList);
      this.calculateNetDifference(this.transactionList);
    }
  }

  sumCount(): number {
    return this.transactionList.reduce((total, transaction) => {
      // Ensure 'count' exists and is a number
      return total + (transaction.count || 0);
    }, 0);
  }

  sumGross(): number {
    return this.transactionList.reduce((total, transaction) => {
      // Ensure 'count' exists and is a number
      return total + (transaction.salePrice * transaction.count || 0);
    }, 0);
  }

  sumDiscount(): number {
    return this.transactionList.reduce((total, transaction) => {
      // Ensure 'count' exists and is a number
      return total + (((transaction.salePrice * transaction.count) * transaction.discountRate) / 100 || 0);
    }, 0);
  }

  sumBuyingCount(): number {
    return this.transactionList.reduce((total, transaction) => {
      // Ensure 'count' exists and is a number
      return total + ((transaction.product.purchasePrice * transaction.count) || 0);
    }, 0);
  }

  sumExcludingVAT(): number {
    // Toplam net tutar ile ürünlerin alış fiyatlarının toplamını çıkarmak
    const totalNet = this.sumNetTotal(); // Toplam net tutarı al
    const totalPurchasePrice = this.transactionList.reduce((total, transaction) => {
      // Alış fiyatı ile miktarın çarpımını topla
      return total + (transaction.product.purchasePrice * transaction.count);
    }, 0);

    // Toplam net tutardan alış fiyatı toplamını çıkart
    return totalNet - totalPurchasePrice;
  }

  // alış kdv 
  transactionVatTotal: any[];
  calculateVatTotals(transactions) {
    const vatTotalsMap: { [saleTaxId: number]: { saleTax: number, totalVat: number } } = {};

    transactions.forEach(transaction => {
      const { saleTaxId, salePrice, count, saleTax } = transaction;

      // Calculate the total amount before VAT
      const totalBeforeVat = salePrice * count;

      // Calculate VAT for this transaction
      const vat = (totalBeforeVat * saleTax) / 100;

      if (!vatTotalsMap[saleTaxId]) {
        vatTotalsMap[saleTaxId] = { saleTax, totalVat: 0 };
      }

      vatTotalsMap[saleTaxId].totalVat += vat;
    });

    // Convert vatTotalsMap to an array
    this.transactionVatTotal = Object.keys(vatTotalsMap).map(saleTaxId => ({
      saleTaxId: +saleTaxId,
      saleTax: vatTotalsMap[+saleTaxId].saleTax,
      totalVat: vatTotalsMap[+saleTaxId].totalVat
    }));

    console.log(this.transactionVatTotal);
    return this.transactionVatTotal;
  }
  // kdv farkı
  vatDifference: number = 0;
  calculateNetVatDifference(transactions) {
    // Calculate total sales VAT
    const vatTotals = this.calculateVatTotals(transactions);
    const totalSalesVat = vatTotals.reduce((total, item) => total + item.totalVat, 0);
    console.log(totalSalesVat);
    // Calculate total purchase VAT
    const purchaseTaxTotals = this.calculatePurchaseTaxTotals(transactions);
    const totalPurchaseVat = purchaseTaxTotals.reduce((total, item) => total + item.totalPurchaseTax, 0);
    console.log(totalPurchaseVat);

    // Calculate the difference
    const netVatDifference = totalSalesVat - totalPurchaseVat;

    // Log the results for debugging
    console.log(`Total Sales VAT: ${totalSalesVat}`);
    console.log(`Total Purchase VAT: ${totalPurchaseVat}`);
    console.log(`Net VAT Difference: ${netVatDifference}`);
    this.vatDifference = netVatDifference;
    return netVatDifference;
  }
  // kdv hariç kar
  transactionPurchaseTaxTotal: any[];
  calculatePurchaseTaxTotals(transactions) {
    const purchaseTaxTotalsMap: { [purchaseTaxId: number]: { purchaseTax: number, totalPurchaseTax: number } } = {};

    transactions.forEach(transaction => {
      const { product, count } = transaction;
      const { purchaseTaxId, purchasePrice, purchaseTax } = product;

      // Calculate the total amount before purchase tax
      const totalBeforeTax = purchasePrice * count;

      // Calculate purchase tax for this transaction
      const purchaseTaxAmount = (totalBeforeTax * purchaseTax) / 100;

      if (!purchaseTaxTotalsMap[purchaseTaxId]) {
        purchaseTaxTotalsMap[purchaseTaxId] = { purchaseTax, totalPurchaseTax: 0 };
      }

      purchaseTaxTotalsMap[purchaseTaxId].totalPurchaseTax += purchaseTaxAmount;
    });

    // Convert purchaseTaxTotalsMap to an array
    this.transactionPurchaseTaxTotal = Object.keys(purchaseTaxTotalsMap).map(purchaseTaxId => ({
      purchaseTaxId: +purchaseTaxId,
      purchaseTax: purchaseTaxTotalsMap[+purchaseTaxId].purchaseTax,
      totalPurchaseTax: purchaseTaxTotalsMap[+purchaseTaxId].totalPurchaseTax
    }));

    console.log(this.transactionPurchaseTaxTotal);
    return this.transactionPurchaseTaxTotal;
  }


  sumNetTotal(): number {
    return this.transactionList.reduce((total, transaction) => {
      const totalPrice = transaction.salePrice * transaction.count;
      if (transaction.discountRate === 0) {
        // No discount applied, just add the total price
        return total + totalPrice;
      } else {
        // Discount applied, calculate the amount after discount
        const discount = (totalPrice * transaction.discountRate) / 100;
        return total + (totalPrice - discount);
      }
    }, 0);
  }

  total: Number = 0;

  calculateNetDifference(transactions) {
    const salePriceTotal = transactions.reduce((total, transaction) => {
      // Satış fiyatı hesapla: (salePrice * count) + (KDV dahil)
      const totalSalePrice = (transaction.total) || 0;
      return total + totalSalePrice;
    }, 0);

    // Toplam alış fiyatını hesapla
    const purchasePriceTotal = transactions.reduce((total, transaction) => {
      const { product, count } = transaction;
      const { purchasePrice, purchaseTax } = product;

      // Alış fiyatına KDV ekle
      const totalPurchasePriceWithTax = (purchasePrice + ((purchasePrice * purchaseTax) / 100)) * count || 0;

      return total + totalPurchasePriceWithTax;
    }, 0);


    // Toplam satış fiyatı ile toplam alış fiyatı arasındaki farkı hesapla
    const netDifference = salePriceTotal - purchasePriceTotal;


    // Net farkı döndür
    this.total = netDifference;
  }



  formatNumber(value: number): string {
    return this.decimalPipe.transform(value, '1.2-2') || '0.00';
  }

  isMailSend: boolean = null;
  async isMailConfirmed(): Promise<boolean> {
    const modal = this.modalService.open(ConfirmDialogComponent, {
      size: 'sm',
      centered: true,
      windowClass: 'modal modal-success'
    });

    modal.componentInstance.data = {
      message: "Teklif mail ile müşteriye iletilsin mi?",
      title: "Mail Gönderme"
    };

    try {
      const result = await modal.result; // Modal sonucunu bekliyoruz
      console.log(result);
      this.isMailSend = result;
    } catch (err) {
      console.log('Diyalog kapatıldı:', err);
      this.isMailSend = false; // Dialog kapatıldığında varsayılan değer
    }

    return this.isMailSend;
  }

  transactionShow(product) {
    const modal = this.modalService.open(TransactionCreateDilaogComponent, {
      size: 'ml',
      centered: true,
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      message: `${product.name}`,
      product: product,
      discountRate: this.company.discountRate,
      transactionId: null
    };

    modal.result.then((result) => {
      if (result) {
        this.transactionList.push(result);
        console.log("İşlem Listesi: ", this.transactionList);
        this.calculateTotalAmount();
        this.calculateVatTotals(this.transactionList);
        this.calculatePurchaseTaxTotals(this.transactionList);
        this.calculateNetVatDifference(this.transactionList);
        this.calculateNetDifference(this.transactionList);
        this.productSelect.writeValue(null);
      }
    }, (reason) => {
      console.log('Modal kapatıldı:', reason);
    });
  }

  onProjectChange(event) {
    this.selectedProjectId = event.id;
    console.log(this.selectedProjectId)
  }

  private searchTimeout: any;
  async onSearch(event: any) {

    const searchTerm: string = event.term;

    // Mevcut bir zamanlayıcı varsa iptal edilir
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    // Yeni bir zamanlayıcı başlatılır ve 3 saniye sonra istek gönderilir

    this.searchTimeout = setTimeout(async () => {

      await this.getAllProjects(searchTerm);

    }, 3000);
  }

  async getAllProjects(search: string) {
    this.blockUI.start("Projeler yükleniyor...")
    const data = await this.projectService.getAllProject(0, 100, search);
    this.project = data.projects;
    this.blockUI.stop();
  }

  showCreateCompanyDialog() {
    this.modalService.open(CreateCompanyComponent,{
      size:'lg',
      windowClass: 'modal modal-success'
    });
    this.companyService.event$.subscribe(async result=>{
      await this.getAllCompanies();
    })
  }

  showCreateProductDialog() {
    this.modalService.open(CreateProductComponent,{
      size:'lg',
      windowClass: 'modal modal-success'
    });
    this.productService.event$.subscribe(async result=>{
      await this.getAllProducts();
    })
  } 


  async getAllProducts() {
    const data = await this.productService.getAllProducts(0, 1000, '');
    console.log(data);
    this.products = data.products.filter(p=>p.id !== 1);
  }

  async getAllCompanies() {
    const data = await this.companyService.getAllCompany('', 0, 1000);
    console.log(data);
    this.companies = data.companies.filter(company => company.id !== 1 && company.id !== 2);
  }

  async onCompanyChange(selectedCompanyId: number) {
    console.log('Seçilen Firma ID:', selectedCompanyId);
    await this.getByIdCompany(selectedCompanyId);
  }

  async getByIdCompany(id) {
    const data = await this.companyService.getByIdCompanyTransaction(id);
    console.log(data);
    this.company = data;
    this.selectedCompanyId = this.company.id
    this.persons = this.company.persons;
    this.requestTask = this.company.requestTasks;
  }

  onPersonChange(selectedPersonId: number) {
    console.log('Seçilen Person ID:', selectedPersonId);
    this.selectedPersonId = selectedPersonId;
    //await this.getByIdCompany(selectedCompanyId);
  }

  onRequsetChange(selectedRequestTaskId: number) {
    console.log('seçilen talep ıd : ', selectedRequestTaskId);
    this.selectedRequestTaskId = selectedRequestTaskId;
  }

  async createOffer() {
    const isEmailConfirm = await this.isMailConfirmed();
    console.log(isEmailConfirm);
    if (isEmailConfirm != null) {
      this.blockUI.start("Teklif oluşturuluyor.");
      const createTransaction = new CreateTransaction();
      createTransaction.startDate = new Date(this.dateTimeStartOptions.defaultDate);
      createTransaction.validityDate = new Date(this.dateTimeEndOptions.defaultDate);
      createTransaction.transactionPrivateNode = this.privateDescription;
      createTransaction.companyId = this.company.id; // company id burada olmalı
      createTransaction.kindId = 8; // kindId'nin nereden geldiğini belirleyin
      createTransaction.userId = _isId; // userId'nin nereden geldiğini belirleyin
      createTransaction.personId = this.selectedPersonId;
      createTransaction.projectId = this.selectedProjectId;
      createTransaction.docNo = this.docNo;
      createTransaction.requestTaskId = this.selectedRequestTaskId;
      createTransaction.descriptionId = this.description.id;
      createTransaction.isMailConfirmed = isEmailConfirm;
      createTransaction.createTransactionProducts = this.transactionList.map(transaction => {
        const transactionProduct = new CreateTransactionProduct();
        transactionProduct.productId = transaction.product.id;
        transactionProduct.warehouseId = transaction.selectedWarehouseId;
        transactionProduct.productCount = transaction.count;
        transactionProduct.productPrice = transaction.salePrice;
        transactionProduct.taxId = transaction.saleTaxId;
        transactionProduct.discountRate = transaction.discountRate;
        transactionProduct.currencyId = transaction.currencyId;
        transactionProduct.description = transaction.description;
        transactionProduct.seriNos = transaction.seriNos;
        transactionProduct.saleSerialNos = transaction.saleSerialNos
        return transactionProduct;
      });
      console.log(createTransaction);

      const response = await this.transactionService.createOffer(createTransaction);
      if (response.status == true) {
        this.blockUI.stop();
        this.toastrService.success(response.message);
        this.router.navigate(['/admin/offer-detail', response.data]);
      } else {
        this.blockUI.stop();
        this.toastrService.error(response.message);
      }
    }
  }
}